import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {GrBanner} from '../../../../../interfaces/banners-interfaces';
import {BannersHttpService} from '../../../../../services/http-services/banners/banners-http.service';

@Component({
  selector: 'gr-banners-on-landing',
  templateUrl: './banners-on-landing.component.html'
})
export class BannersOnLandingComponent implements OnInit, OnChanges {
  @Input() isBannerChange = false;
  @Output() bannerForEdit: EventEmitter<GrBanner> = new EventEmitter();
  @Output() bannerForDelete: EventEmitter<GrBanner> = new EventEmitter();
  bannersByPosition: any = [];
  bannerPositionArray = [
    {name: 'A', value: 1},
    {name: 'B', value: 2},
    {name: 'C', value: 3},
    {name: 'D', value: 4},
    {name: 'E', value: 5},
    {name: 'F', value: 6},
  ];

  constructor(private bannersHttpService: BannersHttpService) {}

  ngOnInit(): void {
    this.getBanners();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.isBannerChange && changes.isBannerChange.currentValue) {
      this.getBanners();
    }
  }

  getBanners(): void {
    this.bannersHttpService.getBanners(true).then(res => {
      this.bannersByPosition = res.data;
    });
  }
}
